import { render, staticRenderFns } from "./idCardComplete.vue?vue&type=template&id=4b29cb6a&scoped=true"
import script from "./idCardComplete.vue?vue&type=script&lang=js"
export * from "./idCardComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b29cb6a",
  null
  
)

export default component.exports